<template>
  <div>
    <b-card v-if="useCard">
      <slot name="content" :emitDone="emitDone">
        <div :class="imageContainerClass">
          <img :class="imageClass" :src="imageSrc" />
        </div>
        <h2 v-if="title" :align="titleAlign" :class="titleClass">{{ title }}</h2>
        <p v-if="message" :class="messageClass">{{ message }}</p>
      </slot>
      <slot name="action" :emitDone="emitDone">
        <b-row v-if="useRowAction" :class="actionRowClass">
          <b-col :md="actionColMd">
            <b-button
              :class="actionButtonClass"
              :variant="buttonVariant"
              :btn-color="buttonBtnColor"
              @click="emitDone"
            >
              {{ buttonText }}
            </b-button>
          </b-col>
        </b-row>
        <div v-else :class="actionWrapperClass">
          <b-button
            :class="actionButtonClass"
            :variant="buttonVariant"
            :btn-color="buttonBtnColor"
            @click="emitDone"
          >
            {{ buttonText }}
          </b-button>
        </div>
      </slot>
    </b-card>

    <template v-else>
      <slot name="content" :emitDone="emitDone">
        <div :class="imageContainerClass">
          <img :class="imageClass" :src="imageSrc" />
        </div>
        <h2 v-if="title" :align="titleAlign" :class="titleClass">{{ title }}</h2>
        <p v-if="message" :class="messageClass">{{ message }}</p>
      </slot>
      <slot name="action" :emitDone="emitDone">
        <b-row v-if="useRowAction" :class="actionRowClass">
          <b-col :md="actionColMd">
            <b-button
              :class="actionButtonClass"
              :variant="buttonVariant"
              :btn-color="buttonBtnColor"
              @click="emitDone"
            >
              {{ buttonText }}
            </b-button>
          </b-col>
        </b-row>
        <div v-else :class="actionWrapperClass">
          <b-button
            :class="actionButtonClass"
            :variant="buttonVariant"
            :btn-color="buttonBtnColor"
            @click="emitDone"
          >
            {{ buttonText }}
          </b-button>
        </div>
      </slot>
    </template>
  </div>
</template>

<script>
export default {
  name: "ThankYouStepperBase",
  props: {
    useCard: {
      type: Boolean,
      default: false,
    },
    imageSrc: {
      type: String,
      required: true,
    },
    imageContainerClass: {
      type: String,
      default: "d-flex justify-content-between",
    },
    imageClass: {
      type: String,
      default: "image",
    },
    title: {
      type: String,
      default: "",
    },
    titleAlign: {
      type: String,
      default: "center",
    },
    titleClass: {
      type: String,
      default: "mt-3",
    },
    message: {
      type: String,
      default: "",
    },
    messageClass: {
      type: String,
      default: "font-weight-bold text-center",
    },
    useRowAction: {
      type: Boolean,
      default: true,
    },
    actionRowClass: {
      type: String,
      default: "mt-3",
    },
    actionColMd: {
      type: String,
      default: "12",
    },
    actionWrapperClass: {
      type: String,
      default: "text-center mt-4",
    },
    actionButtonClass: {
      type: String,
      default: "btn btn-block",
    },
    buttonText: {
      type: String,
      default: "Done",
    },
    buttonVariant: {
      type: String,
      default: undefined,
    },
    buttonBtnColor: {
      type: String,
      default: "primary",
    },
  },
  methods: {
    emitDone() {
      this.$emit("done");
    },
  },
};
</script>
